import { useQuery } from '@tanstack/react-query'
import useAuth from '@/features/auth/hooks/use-auth'
import { queryKeys } from '@/shared/constants/query-keys'
import { projectsAdminV2Service } from '../services/projects-admin-v2.service'

/**
 * Proyectos activos (`{ id: prj_, name, code }`) para los selects v2 que los
 * cascadean —el form de subtipos, y más adelante otros consumidores—. Sólo corre
 * con sesión staff v2; los datos casi no cambian, así que se cachean largo.
 */
export const useProjectsV2LookupQuery = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const { auth } = useAuth()
  const accessToken = auth?.v2AccessToken ?? ''
  return useQuery({
    queryKey: queryKeys.projects.lookupV2(),
    queryFn: async () => await projectsAdminV2Service.lookup(accessToken),
    enabled: enabled && Boolean(accessToken),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false
  })
}
